// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3ogmM","inputWrap":"styles_inputWrap__R77NS","input":"styles_input__3rLhr"};